import { z } from "zod";

export const locationFormSchema = z.object({
  isDefault: z.boolean(),
  address1: z.string(),
  address2: z.string(),
  city: z.string(),
  country: z.object({
    name: z.string(),
    code: z.string(),
  }),
  zip: z.string(),
  companyName: z.string(),
});

export type LocationFormValues = z.infer<typeof locationFormSchema>;
